import { LocaleKey } from '@percent/cause-dashboard/i18n/config'
import { AgentVerificationProgramType } from '@percent/cause-dashboard/services/agentVerification/AgentVerification.types'

export type DocumentTypeOption = { key: LocaleKey; recommended?: boolean }

export const EDU_DOCUMENT_TYPES: DocumentTypeOption[] = [
  { key: 'agentVerificationDocuments.reupload.documents.teachingLicense', recommended: true },
  { key: 'agentVerificationDocuments.reupload.documents.recentPayStub', recommended: true },
  { key: 'agentVerificationDocuments.reupload.documents.signedLetterOfEmployment' },
  { key: 'agentVerificationDocuments.reupload.documents.signedEmploymentContract' },
  { key: 'agentVerificationDocuments.reupload.documents.mostRecentTaxReturn' },
  { key: 'agentVerificationDocuments.reupload.documents.employmentRecord' },
  { key: 'agentVerificationDocuments.reupload.documents.validTeacherId' }
]

export const NONPROFIT_DOCUMENT_TYPES: DocumentTypeOption[] = [
  { key: 'agentVerificationDocuments.bulletList.governmentIssuedDoc' },
  { key: 'agentVerificationDocuments.bulletList.payslip' },
  { key: 'agentVerificationDocuments.bulletList.bankStatement' },
  { key: 'agentVerificationDocuments.bulletList.idCard' }
]

export const documentTypesFor = (programType: AgentVerificationProgramType | null | undefined): DocumentTypeOption[] =>
  programType === 'education' ? EDU_DOCUMENT_TYPES : NONPROFIT_DOCUMENT_TYPES
